enum ChartMetric {
  Conversions = 'Conversions',
  Impressions = 'Impressions',
  ImpressionsOmnichannel = 'Omnichannel Impressions',
  ImpressionsYoutube = 'YouTube Impressions',
  ImpressionsAudio = 'Audio Impressions',
  FootTrafficVisits = 'Foot Traffic Visits',
}

export default ChartMetric;
